/*
 * @Author: wzh
 * @LastEditTime: 2023-01-06 17:58:55
 * @Description: 移动端 路由
 */
export default [
	// 首页
	{
		path: "/mAuthServer",
		name: "home",
		component: () => import("@/views/mViews/home/index.vue"),
		meta: {
			requireAuth: true, //未登录不能直接进入的页面
		},
	},
	// 选择登录方式（未使用）
	{
		path: "/mloginList",
		name: "LoginList",
		component: () => import("@/views/mViews/login/LoginList.vue"),
		meta: {
			title: "选择登录方式",
			isShowArrow: true,
		},
	},
	//修改别名
	{
		path: "/mchangeName",
		name: "ChangeUserName",
		component: () => import("@/views/mViews/home/ChangeUserName.vue"),
		meta: {
			requireAuth: true, //未登录不能直接进入的页面
			title: "修改别名",
			field: "update_alias",
			isShowArrow: true,
		},
	},
	//修改密码
	{
		path: "/mpassword",
		name: "Password",
		component: () => import("@/views/mViews/home/Password.vue"),
		meta: {
			title: "修改密码",
			field: "update_password",
			isShowArrow: true,
		},
	},

	//身份绑定
	{
		path: "/mbindIdentity",
		name: "BindIdentity",
		component: () => import("@/views/mViews/home/BindIdentity.vue"),
		meta: {
			title: "绑定身份",
			field: "bind_identity",
			isShowArrow: true,
		},
	},
];
